export default "__VITE_ASSET__DoS6h8$m__"